// import { Box, Flex, Image, Text, Badge, Divider, Button } from '@chakra-ui/react';
// import { useCurrency } from 'hooks/useCurrency';
// import { BsCart3 } from 'react-icons/bs';

// export default function VendorMoqToast({ t, item, vendorSummary, convertedValues }) {
//     const vendorTotalRaw = convertedValues?.vendorTotal ?? vendorSummary?.vendor_total ?? 0;
//     const moqRaw = convertedValues?.moq ?? vendorSummary?.vendor_moq ?? 200;
//     const remainingRaw =
//         convertedValues?.remaining ?? vendorSummary?.remaining_to_vendor_moq ?? moqRaw;
//     const itemTotalRaw = convertedValues?.itemTotal ?? item?.total_price ?? 0;
//     const met = vendorSummary?.vendor_moq_met ?? remainingRaw === 0;

//     const vendorTotalConv = useCurrency(vendorTotalRaw);
//     const moqConv = useCurrency(moqRaw);
//     const remainingConv = useCurrency(remainingRaw);
//     const itemTotalConv = useCurrency(itemTotalRaw);

//     const sym = vendorTotalConv?.symbol ?? '$';
//     const fmt = (v) =>
//         Number(v ?? 0).toLocaleString(undefined, {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//         });

//     const vendorTotal = vendorTotalConv?.price ?? vendorTotalRaw;
//     const moq = moqConv?.price ?? moqRaw;
//     const remaining = remainingConv?.price ?? remainingRaw;
//     const itemTotal = itemTotalConv?.price ?? itemTotalRaw;

//     const progressPct = Math.min(100, (vendorTotal / moq) * 100);
//     const barColor = met ? 'green.400' : progressPct >= 60 ? 'yellow.400' : 'red.400';
//     const vendorName = vendorSummary?.vendor ?? item?.vendor ?? 'Vendor';

//     return (
//         <Box
//             opacity={t.visible ? 1 : 0}
//             transition="all 0.25s ease-in-out"
//             transform={t.visible ? 'translateY(0)' : 'translateY(-8px)'}
//             position="relative"
//             bg="white"
//             _dark={{ bg: 'gray.800', borderColor: 'gray.700' }}
//             borderRadius="2xl"
//             boxShadow="0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.02)"
//             border="1px solid"
//             borderColor="gray.100"
//             overflow="hidden"
//             w="360px"
//             _hover={{ boxShadow: 'xl', transform: 'translateY(-2px)' }}>
//             {/* Left colour bar */}
//             <Box
//                 position="absolute"
//                 left={0}
//                 top={0}
//                 bottom={0}
//                 w="4px"
//                 bg={barColor}
//                 borderTopLeftRadius="2xl"
//                 borderBottomLeftRadius="2xl"
//             />

//             <Box p={4} pl={6}>
//                 {/* Item row */}
//                 <Flex gap={3} align="flex-start">
//                     {item?.imageurl && (
//                         <Image
//                             src={item.imageurl}
//                             alt={item.name ?? 'product'}
//                             boxSize="56px"
//                             borderRadius="lg"
//                             objectFit="cover"
//                             flexShrink={0}
//                             fallbackSrc="https://placehold.co/56x56?text=img"
//                         />
//                     )}
//                     <Box flex={1} minW={0}>
//                         <Flex justify="space-between" align="flex-start" gap={2}>
//                             <Text
//                                 fontSize="14px"
//                                 fontWeight="600"
//                                 noOfLines={1}
//                                 color="gray.800"
//                                 _dark={{ color: 'gray.100' }}>
//                                 {item?.name ?? 'Product'}
//                             </Text>
//                             <Text fontSize="12px" fontWeight="500" color="gray.500" flexShrink={0}>
//                                 Qty {item?.quantity ?? 1}
//                             </Text>
//                         </Flex>
//                         <Text fontSize="13px" color="gray.500" mt="1px">
//                             {sym} {fmt(itemTotal)}
//                         </Text>
//                     </Box>
//                 </Flex>

//                 <Divider my={3} />

//                 {/* Vendor MOQ row */}
//                 <Box>
//                     <Flex justify="space-between" align="flex-start" mb={2} gap={3}>
//                         <Box>
//                             <Text
//                                 fontSize="14px"
//                                 fontWeight="600"
//                                 color="gray.800"
//                                 _dark={{ color: 'gray.100' }}>
//                                 {vendorName}
//                             </Text>
//                             <Text fontSize="12px" color="gray.500" mt="0px">
//                                 Minimum order
//                             </Text>
//                         </Box>
//                         <Box textAlign="right" flexShrink={0}>
//                             <Text
//                                 fontSize="13px"
//                                 fontWeight="500"
//                                 color="gray.800"
//                                 _dark={{ color: 'gray.100' }}>
//                                 {sym} {fmt(vendorTotal)} / {sym} {fmt(moq)}
//                             </Text>
//                             <Badge
//                                 mt={1.5}
//                                 fontSize="11px"
//                                 borderRadius="full"
//                                 px={2.5}
//                                 py={0.5}
//                                 colorScheme={met ? 'green' : 'orange'}
//                                 fontWeight="500">
//                                 {met ? '✓ Met' : `${sym} ${fmt(remaining)} left`}
//                             </Badge>
//                         </Box>
//                     </Flex>

//                     <Box
//                         h="8px"
//                         borderRadius="full"
//                         bg="gray.100"
//                         _dark={{ bg: 'gray.700' }}
//                         overflow="hidden">
//                         <Box
//                             h="100%"
//                             borderRadius="full"
//                             bg={barColor}
//                             w={`${progressPct}%`}
//                             transition="width 0.4s cubic-bezier(0.2, 0.9, 0.4, 1.1)"
//                         />
//                     </Box>
//                 </Box>

//                 <Button
//                     mt={3}
//                     w="full"
//                     size="sm"
//                     bg="#1B3B5F"
//                     color="white"
//                     borderRadius="lg"
//                     fontWeight="600"
//                     fontSize="13px"
//                     leftIcon={<BsCart3 size={14} />}
//                     _hover={{ bg: '#0f2942' }}
//                     _active={{ bg: '#0a1f33' }}
//                     onClick={() => {
//                         window.location.href = '/dashboard/cart';
//                     }}>
//                     Go to cart
//                 </Button>
//             </Box>
//         </Box>
//     );
// }

// import { memo, useMemo } from 'react';
// import { Box, Flex, Image, Text, Button, IconButton } from '@chakra-ui/react';
// import toast from 'react-hot-toast';
// import { useCurrency } from 'hooks/useCurrency';
// import PlaceHolder from 'assets/placeholder.png';

// /* ─────────────────────────────────────────────────────────────
//    BRAND TOKENS
//    ───────────────────────────────────────────────────────────── */
// const NAVY        = '#1B3B5F';
// const NAVY_DEEP   = '#0F2940';
// const INK         = '#1A2740';
// const MUTED       = '#5A6B7E';
// const FAINT       = '#8896AE';
// const SURFACE     = '#FFFFFF';
// const SURFACE_ALT = '#F7F9FB';
// const BORDER      = '#E8EDF5';

// const SUCCESS     = '#10B981';
// const SUCCESS_BG  = '#ECFDF5';
// const WARNING     = '#EA580C';
// const WARNING_BG  = '#FFF7ED';
// const DANGER      = '#E53E3E';
// const DANGER_BG   = '#FEF2F2';

// const FONT = "'Bricolage Grotesque', sans-serif";

// const SHADOW = '0 12px 32px rgba(27,59,95,0.16), 0 4px 12px rgba(27,59,95,0.08)';

// /* Progress-bar color thresholds (% to MOQ) */
// const getProgressColor = (pct, met) => {
//     if (met) return { fg: SUCCESS, bg: SUCCESS_BG, label: 'MOQ MET' };
//     if (pct >= 80) return { fg: NAVY,    bg: '#EFF6FF',  label: 'ALMOST THERE' };
//     if (pct >= 30) return { fg: WARNING, bg: WARNING_BG, label: 'KEEP GOING' };
//     return { fg: DANGER, bg: DANGER_BG, label: 'JUST STARTED' };
// };

// /* ─────────────────────────────────────────────────────────────
//    ICONS
//    ───────────────────────────────────────────────────────────── */

// const ArrowRightIcon = (props) => (
//     <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
//         <path
//             d="M5 12h14M13 5l7 7-7 7"
//             stroke="currentColor"
//             strokeWidth="2.2"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// const CloseIcon = (props) => (
//     <svg width="10" height="10" viewBox="0 0 24 24" fill="none" {...props}>
//         <path
//             d="M18 6L6 18M6 6l12 12"
//             stroke="currentColor"
//             strokeWidth="2.5"
//             strokeLinecap="round"
//         />
//     </svg>
// );

// const CheckIcon = (props) => (
//     <svg width="10" height="10" viewBox="0 0 24 24" fill="none" {...props}>
//         <path
//             d="M20 6L9 17l-5-5"
//             stroke="currentColor"
//             strokeWidth="2.8"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// /* ─────────────────────────────────────────────────────────────
//    MAIN — Concept B
//    Top edge of card IS the progress bar.
//    ───────────────────────────────────────────────────────────── */

// const VendorMoqToast = memo(function VendorMoqToast({
//     t, item, vendorSummary, convertedValues,
// }) {
//     /* ── Raw values with fallback chain ──────────────────────  */
//     const vendorTotalRaw = convertedValues?.vendorTotal ?? vendorSummary?.vendor_total ?? 0;
//     const moqRaw         = convertedValues?.moq         ?? vendorSummary?.vendor_moq ?? 0;
//     const remainingRaw   = convertedValues?.remaining   ?? vendorSummary?.remaining_to_vendor_moq ?? moqRaw;
//     const itemTotalRaw   = convertedValues?.itemTotal   ?? item?.total_price ?? 0;
//     const met = vendorSummary?.vendor_moq_met ?? remainingRaw <= 0;

//     /* ── Currency conversion ─────────────────────────────────  */
//     const vendorTotalConv = useCurrency(vendorTotalRaw);
//     const moqConv         = useCurrency(moqRaw);
//     const remainingConv   = useCurrency(remainingRaw);
//     const itemTotalConv   = useCurrency(itemTotalRaw);

//     const sym = vendorTotalConv?.symbol ?? '₦';
//     const fmt = (v) =>
//         Number(v ?? 0).toLocaleString(undefined, {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2,
//         });

//     /* Shorter format for the LEFT badge (kilo notation when > 10k) */
//     const fmtShort = (v) => {
//         const n = Number(v ?? 0);
//         if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
//         if (n >= 10000)   return `${Math.round(n / 1000)}K`;
//         if (n >= 1000)    return `${(n / 1000).toFixed(1)}K`;
//         return Math.round(n).toLocaleString();
//     };

//     const vendorTotal = vendorTotalConv?.price ?? vendorTotalRaw;
//     const moq         = moqConv?.price ?? moqRaw;
//     const remaining   = remainingConv?.price ?? remainingRaw;
//     const itemTotal   = itemTotalConv?.price ?? itemTotalRaw;

//     /* ── Derived state ───────────────────────────────────────  */
//     const progressPct = useMemo(() => {
//         if (!moq || moq <= 0) return 0;
//         return Math.min(100, Math.max(0, (vendorTotal / moq) * 100));
//     }, [vendorTotal, moq]);

//     const status = useMemo(() => getProgressColor(progressPct, met), [progressPct, met]);
//     const vendorName = vendorSummary?.vendor ?? item?.vendor ?? 'Vendor';
//     const productQty = item?.quantity ?? 1;

//     /* ── Handlers ────────────────────────────────────────────  */
//     const handleGoToCart = () => {
//         toast.dismiss(t?.id);
//         /* window.location instead of useNavigate() — react-hot-toast renders
//            in a portal outside the Router context, so useNavigate() crashes. */
//         if (typeof window !== 'undefined') {
//             window.location.href = '/dashboard/cart';
//         }
//     };

//     const handleDismiss = () => {
//         toast.dismiss(t?.id);
//     };

//     return (
//         <Box
//             opacity={t?.visible ? 1 : 0}
//             transform={t?.visible ? 'translateY(0)' : 'translateY(-8px)'}
//             transition="opacity 0.25s ease, transform 0.25s ease"
//             bg={SURFACE}
//             borderRadius="12px"
//             boxShadow={SHADOW}
//             border="1px solid"
//             borderColor={BORDER}
//             overflow="hidden"
//             w={{ base: 'calc(100vw - 24px)', sm: '320px' }}
//             maxW="320px"
//             fontFamily={FONT}
//             position="relative"
//         >
//             {/* ── TOP EDGE = PROGRESS BAR ──────────────────────── */}
//             <Box
//                 h="4px"
//                 w="full"
//                 bg={status.bg}
//                 position="relative"
//                 overflow="hidden"
//             >
//                 <Box
//                     h="full"
//                     bg={status.fg}
//                     w={`${progressPct}%`}
//                     transition="width 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1)"
//                 />
//             </Box>

//             {/* ── BODY ─────────────────────────────────────────── */}
//             <Box p="12px 14px">
//                 {/* Status row: label + close button */}
//                 <Flex justify="space-between" align="center" mb="10px">
//                     <Flex align="center" gap="5px">
//                         <Box w="6px" h="6px" borderRadius="full" bg={status.fg} />
//                         <Text
//                             fontSize="9.5px"
//                             fontWeight="800"
//                             color={status.fg}
//                             letterSpacing="0.08em"
//                         >
//                             {status.label}
//                         </Text>
//                     </Flex>
//                     <IconButton
//                         aria-label="Dismiss"
//                         icon={<CloseIcon />}
//                         onClick={handleDismiss}
//                         size="xs"
//                         w="20px"
//                         h="20px"
//                         minW="20px"
//                         borderRadius="full"
//                         bg="transparent"
//                         color={FAINT}
//                         _hover={{ bg: SURFACE_ALT, color: INK }}
//                     />
//                 </Flex>

//                 {/* Product row */}
//                 <Flex gap="10px" align="center" mb="10px">
//                     <Box
//                         w="42px"
//                         h="42px"
//                         borderRadius="8px"
//                         bg={SURFACE_ALT}
//                         border="1px solid"
//                         borderColor={BORDER}
//                         overflow="hidden"
//                         flexShrink={0}
//                     >
//                         <Image
//                             src={item?.imageurl}
//                             alt=""
//                             w="full"
//                             h="full"
//                             objectFit="cover"
//                             fallbackSrc={PlaceHolder}
//                         />
//                     </Box>
//                     <Box flex="1" minW="0">
//                         <Text
//                             fontSize="12.5px"
//                             fontWeight="700"
//                             color={INK}
//                             noOfLines={1}
//                             lineHeight="1.3"
//                             fontFamily={FONT}
//                         >
//                             {item?.name ?? 'Product'}
//                         </Text>
//                         <Flex gap="5px" align="center" mt="2px">
//                             <Text fontSize="11px" fontWeight="800" color={NAVY} fontFamily={FONT}>
//                                 {sym}{fmt(itemTotal)}
//                             </Text>
//                             <Text fontSize="10px" color={FAINT}>•</Text>
//                             <Text fontSize="10.5px" color={MUTED} fontWeight="600">
//                                 Qty {productQty}
//                             </Text>
//                         </Flex>
//                     </Box>
//                 </Flex>

//                 {/* Divider */}
//                 <Box h="1px" bg={BORDER} mb="10px" />

//                 {/* MOQ summary */}
//                 <Box mb="12px">
//                     <Flex justify="space-between" align="baseline" mb="3px" gap="8px">
//                         <Text
//                             fontSize="10px"
//                             fontWeight="800"
//                             color={INK}
//                             letterSpacing="0.06em"
//                             noOfLines={1}
//                             fontFamily={FONT}
//                         >
//                             {vendorName.toUpperCase()}
//                         </Text>
//                         <Flex
//                             align="center"
//                             gap="3px"
//                             bg={status.bg}
//                             color={status.fg}
//                             border={`1px solid ${status.fg}30`}
//                             px="7px"
//                             py="2px"
//                             borderRadius="full"
//                             fontSize="9px"
//                             fontWeight="800"
//                             letterSpacing="0.04em"
//                             flexShrink={0}
//                         >
//                             {met ? (
//                                 <>
//                                     <CheckIcon /> MET
//                                 </>
//                             ) : (
//                                 `${sym}${fmtShort(remaining)} LEFT`
//                             )}
//                         </Flex>
//                     </Flex>
//                     <Text fontSize="10.5px" color={MUTED} lineHeight="1.4">
//                         <Text as="span" color={INK} fontWeight="700">
//                             {sym}{fmt(vendorTotal)}
//                         </Text>
//                         {' of '}
//                         <Text as="span" color={MUTED} fontWeight="600">
//                             {sym}{fmt(moq)}
//                         </Text>
//                         {' minimum order'}
//                     </Text>
//                 </Box>

//                 {/* CTA */}
//                 <Button
//                     w="full"
//                     h="34px"
//                     bg={NAVY}
//                     color="white"
//                     _hover={{ bg: NAVY_DEEP }}
//                     _active={{ bg: NAVY_DEEP }}
//                     borderRadius="8px"
//                     fontWeight="700"
//                     fontSize="11.5px"
//                     fontFamily={FONT}
//                     onClick={handleGoToCart}
//                     rightIcon={<ArrowRightIcon />}
//                 >
//                     Go to cart
//                 </Button>
//             </Box>
//         </Box>
//     );
// });

// export default VendorMoqToast;


import { memo, useMemo } from 'react';
import { Box, Flex, Image, Text, Button, IconButton } from '@chakra-ui/react';
import toast from 'react-hot-toast';
import { useCurrency } from 'hooks/useCurrency';
import PlaceHolder from 'assets/placeholder.png';

/* ─────────────────────────────────────────────────────────────
   BRAND TOKENS
   ───────────────────────────────────────────────────────────── */
const NAVY        = '#1B3B5F';
const NAVY_DEEP   = '#0F2940';
const INK         = '#1A2740';
const MUTED       = '#5A6B7E';
const FAINT       = '#8896AE';
const SURFACE     = '#FFFFFF';
const SURFACE_ALT = '#F7F9FB';
const BORDER      = '#E8EDF5';

const SUCCESS     = '#10B981';
const SUCCESS_BG  = '#ECFDF5';
const WARNING     = '#EA580C';
const WARNING_BG  = '#FFF7ED';
const DANGER      = '#E53E3E';
const DANGER_BG   = '#FEF2F2';

const FONT = "'Bricolage Grotesque', sans-serif";
const SHADOW = '0 12px 32px rgba(27,59,95,0.16), 0 4px 12px rgba(27,59,95,0.08)';

/* Progress-bar color thresholds */
const getProgressColor = (pct, met) => {
    if (met) return { fg: SUCCESS, bg: SUCCESS_BG, label: 'MOQ MET' };
    if (pct >= 80) return { fg: NAVY,    bg: '#EFF6FF',  label: 'ALMOST THERE' };
    if (pct >= 30) return { fg: WARNING, bg: WARNING_BG, label: 'KEEP GOING' };
    return { fg: DANGER, bg: DANGER_BG, label: 'JUST STARTED' };
};

/* ─────────────────────────────────────────────────────────────
   ICONS
   ───────────────────────────────────────────────────────────── */
const ArrowRightIcon = (props) => (
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M5 12h14M13 5l7 7-7 7" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

const CloseIcon = (props) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
    </svg>
);

const CheckIcon = (props) => (
    <svg width="10" height="10" viewBox="0 0 24 24" fill="none" {...props}>
        <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

/* ─────────────────────────────────────────────────────────────
   MAIN COMPONENT
   ───────────────────────────────────────────────────────────── */
const VendorMoqToast = memo(function VendorMoqToast({
    t, item, vendorSummary, convertedValues,
}) {
    // Raw values
    const vendorTotalRaw = convertedValues?.vendorTotal ?? vendorSummary?.vendor_total ?? 0;
    const moqRaw         = convertedValues?.moq         ?? vendorSummary?.vendor_moq ?? 0;
    const remainingRaw   = convertedValues?.remaining   ?? vendorSummary?.remaining_to_vendor_moq ?? moqRaw;
    const itemTotalRaw   = convertedValues?.itemTotal   ?? item?.total_price ?? 0;
    const met = vendorSummary?.vendor_moq_met ?? remainingRaw <= 0;

    // Currency conversions
    const vendorTotalConv = useCurrency(vendorTotalRaw);
    const moqConv         = useCurrency(moqRaw);
    const remainingConv   = useCurrency(remainingRaw);
    const itemTotalConv   = useCurrency(itemTotalRaw);

    const sym = vendorTotalConv?.symbol ?? '₦';
    const fmt = (v) => Number(v ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmtShort = (v) => {
        const n = Number(v ?? 0);
        if (n >= 1000000) return `${(n / 1000000).toFixed(1)}M`;
        if (n >= 10000)   return `${Math.round(n / 1000)}K`;
        if (n >= 1000)    return `${(n / 1000).toFixed(1)}K`;
        return Math.round(n).toLocaleString();
    };

    const vendorTotal = vendorTotalConv?.price ?? vendorTotalRaw;
    const moq         = moqConv?.price ?? moqRaw;
    const remaining   = remainingConv?.price ?? remainingRaw;
    const itemTotal   = itemTotalConv?.price ?? itemTotalRaw;

    const progressPct = useMemo(() => {
        if (!moq || moq <= 0) return 0;
        return Math.min(100, Math.max(0, (vendorTotal / moq) * 100));
    }, [vendorTotal, moq]);

    const status = useMemo(() => getProgressColor(progressPct, met), [progressPct, met]);
    const vendorName = vendorSummary?.vendor ?? item?.vendor ?? 'Vendor';
    const productQty = item?.quantity ?? 1;

    const handleGoToCart = () => {
        toast.dismiss(t?.id);
        if (typeof window !== 'undefined') {
            window.location.href = '/dashboard/cart';
        }
    };

    const handleDismiss = () => {
        toast.dismiss(t?.id);
    };

    return (
        <Box
            opacity={t?.visible ? 1 : 0}
            transform={t?.visible ? 'translateY(0)' : 'translateY(-8px)'}
            transition="opacity 0.25s ease, transform 0.25s ease"
            bg={SURFACE}
            borderRadius="12px"
            boxShadow={SHADOW}
            border="1px solid"
            borderColor={BORDER}
            overflow="hidden"
            w="auto"
            maxW={{ base: "280px", sm: "320px" }}
            width="100%"
            fontFamily={FONT}
            position="relative"
        >
            {/* Top edge progress bar */}
            <Box h="4px" w="full" bg={status.bg} position="relative" overflow="hidden">
                <Box h="full" bg={status.fg} w={`${progressPct}%`} transition="width 0.6s cubic-bezier(0.2, 0.9, 0.4, 1.1)" />
            </Box>

            <Box p="10px 12px">
                <Flex justify="space-between" align="center" mb="8px">
                    <Flex align="center" gap="5px">
                        <Box w="6px" h="6px" borderRadius="full" bg={status.fg} />
                        <Text fontSize="9px" fontWeight="800" color={status.fg} letterSpacing="0.08em">
                            {status.label}
                        </Text>
                    </Flex>
                    <IconButton
                        aria-label="Dismiss"
                        icon={<CloseIcon />}
                        onClick={handleDismiss}
                        size="xs"
                        w="18px"
                        h="18px"
                        minW="18px"
                        borderRadius="full"
                        bg="transparent"
                        color={FAINT}
                        _hover={{ bg: SURFACE_ALT, color: INK }}
                    />
                </Flex>

                <Flex gap="8px" align="center" mb="8px">
                    <Box w="36px" h="36px" borderRadius="8px" bg={SURFACE_ALT} border="1px solid" borderColor={BORDER} overflow="hidden" flexShrink={0}>
                        <Image src={item?.imageurl} alt="" w="full" h="full" objectFit="cover" fallbackSrc={PlaceHolder} />
                    </Box>
                    <Box flex="1" minW="0">
                        <Text fontSize="11.5px" fontWeight="700" color={INK} noOfLines={1} lineHeight="1.3">
                            {item?.name ?? 'Product'}
                        </Text>
                        <Flex gap="4px" align="center" mt="1px">
                            <Text fontSize="10px" fontWeight="800" color={NAVY}>
                                {sym}{fmt(itemTotal)}
                            </Text>
                            <Text fontSize="9px" color={FAINT}>•</Text>
                            <Text fontSize="9.5px" color={MUTED} fontWeight="600">
                                Qty {productQty}
                            </Text>
                        </Flex>
                    </Box>
                </Flex>

                <Box h="1px" bg={BORDER} mb="8px" />

                <Box mb="10px">
                    <Flex justify="space-between" align="baseline" mb="2px" gap="6px">
                        <Text fontSize="9px" fontWeight="800" color={INK} letterSpacing="0.06em" noOfLines={1}>
                            {vendorName.toUpperCase()}
                        </Text>
                        <Flex align="center" gap="2px" bg={status.bg} color={status.fg} border={`1px solid ${status.fg}30`} px="5px" py="1px" borderRadius="full" fontSize="8px" fontWeight="800" letterSpacing="0.04em" flexShrink={0}>
                            {met ? <><CheckIcon /> MET</> : `${sym}${fmtShort(remaining)} LEFT`}
                        </Flex>
                    </Flex>
                    <Text fontSize="9.5px" color={MUTED} lineHeight="1.3">
                        <Text as="span" color={INK} fontWeight="700">{sym}{fmt(vendorTotal)}</Text>
                        {' of '}
                        <Text as="span" color={MUTED} fontWeight="600">{sym}{fmt(moq)}</Text>
                        {' minimum order'}
                    </Text>
                </Box>

                <Button
                    w="full"
                    h="30px"
                    bg={NAVY}
                    color="white"
                    _hover={{ bg: NAVY_DEEP }}
                    borderRadius="8px"
                    fontWeight="700"
                    fontSize="10.5px"
                    onClick={handleGoToCart}
                    rightIcon={<ArrowRightIcon />}
                >
                    Go to cart
                </Button>
            </Box>
        </Box>
    );
});

/* ─────────────────────────────────────────────────────────────
   Helper to show the toast at TOP‑RIGHT corner
   ───────────────────────────────────────────────────────────── */
export const showVendorMoqToast = (params) => {
    toast.custom(
        (t) => <VendorMoqToast t={t} {...params} />,
        {
            position: 'top-right',
            duration: 8000,
            style: {
                marginTop: '16px',
                marginRight: '16px',
            },
        }
    );
};

export default VendorMoqToast;